// тут описываем тип то что приходит с бека в сыром виде
const tariffPlansResourceDtoType = {

};

export default tariffPlansResourceDtoType;
